export default "__VITE_ASSET__19348f61__"